import './en';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/bs-moment/locale/index.js
// module id = ../../../../ngx-bootstrap/bs-moment/locale/index.js
// module chunks = 3